export interface AdStyle {
  id: string;
  image_url: string;
  name?: string;
  name_id?: string;
}

export interface AdStyleCategory {
  category: "all" | "viral" | "offer" | "testimonials" | "custom";
  isCustom?: boolean;
  images: AdStyle[];
}

export const adStylesMock: AdStyleCategory[] = [
  {
    category: "viral",
    images: [
      {
        id: "v1",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/templates/authority-news",
        name: "Authority News",
        name_id: "authority-news",
      },
      {
        id: "v2",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/templates/why-choose-us",
        name: "Why Choose Us",
        name_id: "why-choose-us",
      },
      {
        id: "v3",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/templates/versus-compare",
        name: "Versus Compare",
        name_id: "versus-compare",
      },
      {
        id: "v4",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/templates/bold-claim",
        name: "Bold Claim",
        name_id: "bold-claim",
      },
      {
        id: "v5",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/templates/emotional-reaction",
        name: "Emotional Reaction",
        name_id: "emotional-reaction",
      },
      {
        id: "v6",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/templates/timeline-transform",
        name: "Timeline Transform",
        name_id: "timeline-transform",
      },
      {
        id: "v7",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/templates/visual-hook",
        name: "Visual Hook",
        name_id: "visual-hook",
      },
      {
        id: "v8",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/templates/lifestyle-native",
        name: "Lifestyle Native",
        name_id: "lifestyle-native",
      },
      {
        id: "seasonal-hook",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/template/seasonal-hook",
        name: "Seasonal Hook",
        name_id: "seasonal-hook",
      },
      {
        id: "illustrated-hook",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/template/illustrated-hook.jpg",
        name: "Illustrated Hook",
        name_id: "illustrated-hook.jpg",
      },
      {
        id: "body-lifestyle-offer",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/template/body-lifestyle-offer.webp",
        name: "Body Lifestyle Offer",
        name_id: "body-lifestyle-offer",
      },
      {
        id: "chat-transformation.webp",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/template/chat-transformation.webp",
        name: "Chat Transformation",
        name_id: "chat-transformation.webp",
      },
      {
        id: "contrast-headline-features.webp",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/template/contrast-headline-features.webp",
        name: "Contrast Headline Features",
        name_id: "contrast-headline-features.webp",
      },
      {
        id: "dark-checklist-bold.webp",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/template/dark-checklist-bold.webp",
        name: "Dark Checklist Bold",
        name_id: "dark-checklist-bold.webp",
      },
      {
        id: "old-new-split.webp",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/template/old-new-split.webp",
        name: "Old New Split",
        name_id: "old-new-split.webp",
      },
      {
        id: "science-stats-stack.webp",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/template/oscience-stats-stack.webp",
        name: "Science Stats Stack",
        name_id: "science-stats-stack.webp",
      },
      {
        id: "sky-product-hero.webp",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/template/sky-product-hero.webp",
        name: "Sky Product Hero",
        name_id: "sky-product-hero.webp",
      },
      {
        id: "stats-proof-person.webp",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/template/stats-proof-person.webp",
        name: "Sky Product Hero",
        name_id: "stats-proof-person.webp",
      },
        {
        id: "fashion-editorial",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/template/fashion-editorial.jpg",
        name: "Fashion Editorial",
        name_id: "fashion-editorial",
      },

      {
        id: "creative-hook",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/template/creative-hook.png",
        name: "Creative Hook",
        name_id: "creative-hook",
      },
      {
        id: "vluxury-hero",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/template/vluxury-hero.png",
        name: "Vluxury Hero",
        name_id: "vluxury-hero",
      },
      {
        id: "lifestyle-comparevs",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/template/lifestyle-comparevs.jpg",
        name: "Lifestyle Comparevs",
        name_id: "lifestyle-comparevs.jpg",
      },
    ],
  },
  {
    category: "offer",
    images: [
      {
        id: "o1",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/templates/product-hero",
        name: "Product Hero",
        name_id: "product-hero",
      },
      {
        id: "o2",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/templates/ingredient-breakdown",
        name: "Ingredient Breakdown",
        name_id: "ingredient-breakdown",
      },
      {
        id: "o3",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/templates/hard-offer",
        name: "Hard Offer",
        name_id: "hard-offer",
      },
      {
        id: "o4",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/templates/lifestyle-benefit",
        name: "Lifestyle Benefit",
        name_id: "lifestyle-benefit",
      },
      {
        id: "o5",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/templates/luxury-offer",
        name: "Luxury Offer",
        name_id: "luxury-offer",
      },
      {
        id: "o6",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/templates/feature-callout",
        name: "Feature Callout",
        name_id: "feature-callout",
      },
      {
        id: "o7",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/templates/science-benefits",
        name: "Science Benefits",
        name_id: "science-benefits",
      },
      {
        id: "o8",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/templates/challenge-cta",
        name: "Challenge CTA",
        name_id: "challenge-cta",
      },
      {
        id: "o9",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/templates/us-vs-them",
        name: "Us vs Them",
        name_id: "us-vs-them",
      },
      {
        id: "hot-sale",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/template/hot-sale.jpg",
        name: "Hot Sale",
        name_id: "hot-sale.jpg",
      },
      {
        id: "bundle-offer",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/template/bundle-offer.png",
        name: "Bundle Offer",
        name_id: "bundle-offer",
      },
      {
        id: "luxury-seasonal",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/template/luxury-seasonal.jpg",
        name: "Luxury Seasonal",
        name_id: "luxury-seasonal",
      },
      {
        id: "combo-flatlay",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/template/combo-flatlay.png",
        name: "Combo Flatlay",
        name_id: "combo-flatlay",
      },
      {
        id: "editorial-offer",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/template/editorial-offer.jpg",
        name: "Editorial Offer",
        name_id: "editorial-offer",
      },
      {
        id: "premium-callout",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/template/premium-callout.jpg",
        name: "Premium Callout",
        name_id: "premium-callout.jpg",
      },
      {
        id: "pain-solution",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/template/pain-solution.jpg",
        name: "Pain Solution",
        name_id: "pain-solution",
      },
      {
        id: "bold-editorial-offer",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/template/bold-editorial-offer.png",
        name: "Bold Editorial Offer",
        name_id: "bold-editorial-offer",
      },
      {
        id: "dark-bundle",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/template/dark-bundle.png",
        name: "Dark Bundle",
        name_id: "dark-bundle",
      },
      {
        id: "bundle-hero",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/template/bundle-hero.jpg",
        name: "Bundle Hero",
        name_id: "bundle-hero",
      },
      {
        id: "direct-offer",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/template/direct-offer.jpg",
        name: "Direct Offer",
        name_id: "direct-offer",
      },
      {
        id: "breakthrough-offer",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/template/breakthrough-offer.jpg",
        name: "Breakthrough Offer",
        name_id: "breakthrough-offer",
      },
      {
        id: "mega-sale",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/template/mega-sale1.jpg",
        name: "Mega Sale",
        name_id: "mega-sale.jpg",
      },
      {
        id: "app-offer",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/template/app1-offer.jpg",
        name: "App Offer",
        name_id: "app-offer",
      },
    ],
  },
  {
    category: "testimonials",
    images: [
      {
        id: "t1",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/templates/testimonial-quote",
        name: "Testimonial Quote",
        name_id: "testimonial-quote",
      },
      {
        id: "t2",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/templates/stat-highlight",
        name: "Stat Highlight",
        name_id: "stat-highlight",
      },
      {
        id: "t3",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/templates/stats-proof",
        name: "Stats Proof",
        name_id: "stats-proof",
      },
      {
        id: "t4",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/templates/before-after-review",
        name: "Before After Review",
        name_id: "before-after-review",
      },
      {
        id: "t5",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/templates/ugc-unboxing",
        name: "UGC Unboxing",
        name_id: "ugc-unboxing",
      },
      {
        id: "t6",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/templates/social-post-review",
        name: "Social Post Review",
        name_id: "social-post-review",
      },
      {
        id: "t7",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/templates/review-showcase",
        name: "Review Showcase",
        name_id: "review-showcase",
      },
      {
        id: "t8",
        image_url:
          "https://fluxi.s3.amazonaws.com/prod/assets/ads/creatives/templates/chat-testimonial",
        name: "Chat Testimonial",
        name_id: "chat-testimonial",
      },
    ],
  },
  {
    category: "custom",
    isCustom: true,
    images: [
      {
        id: "custom-reference",
        image_url: "",
        name: "Custom Reference",
        name_id: "custom-reference",
      },
    ],
  },
];
